import { Bell } from "lucide-react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { useWhatsNewStore } from "@/stores/useWhatsNewStore";

/**
 * Notification bell for product updates. `compact` is a plain icon with an unread dot, for the
 * thin strip at the top of the page; the default is a bordered round button (mobile header).
 */
export default function WhatsNewBell({ className = "", compact = false }) {
  const unread = useWhatsNewStore((state) => state.unread.length);
  const open = useWhatsNewStore((state) => state.open);
  const label = unread > 0 ? `What's new: ${unread} new ${unread === 1 ? "update" : "updates"}` : "What's new";
  return (
    <button
      type="button"
      onClick={open}
      title={label}
      aria-label={unread > 0 ? `What's new, ${unread} unread` : "What's new"}
      className={twMerge(
        clsx(
          "relative flex items-center justify-center rounded-full text-gray-500 transition-colors hover:text-secondary active:scale-95 dark:text-gray-400",
          compact
            ? "h-7 w-7 hover:bg-gray-100 dark:hover:bg-gray-800"
            : "h-9 w-9 border border-gray-200/80 bg-white shadow-xs hover:border-secondary/30 dark:border-gray-800 dark:bg-gray-900",
          className,
        ),
      )}
    >
      <Bell size={compact ? 16 : 17} strokeWidth={1.8} />
      {unread > 0 && (
        <span
          aria-hidden="true"
          className={`absolute rounded-full bg-secondary ring-2 ring-white dark:ring-gray-950 ${compact ? "right-1 top-1 h-2 w-2" : "right-0.5 top-0.5 h-2.5 w-2.5"}`}
        />
      )}
    </button>
  );
}
